import PropTypes from 'prop-types';
import React, { useState, useRef, useEffect, useLayoutEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { Route } from 'react-router-dom';
import { routes } from 'routes';
import Topbar from 'components/Topbar';
import Snackbar from 'components/Snackbar';
import { initApp } from 'redux/modules/app/effects';
import { LoadingBig } from 'components/LoadingBig';
import ErrorFeedback from 'modules/error-handler';
import { AppContainerDiv, TopContainer, ContentContainer } from './styled';
import { ErrorBoundary, FallbackErrorComponent } from 'modules/sentry';
import ScrollElementContext from './context';
import { FeatureFlagProvider } from 'utils/hooks/useFeatureFlags';
import { getClientConfig } from 'redux/modules/client-config/selectors';
import { TopBarMenuButtonStateProvider } from '../../components/Topbar/providers/top-bar-menu-button-state-provider';
import { getTenantPreLoginConfig } from 'tenant/teanantPreLoginConfig';

const actionCreators = {
  initApp,
};

const LoggedRoutes = ({ initApp, appLoading }) => {
  const scrollElement = useRef(null);
  const [scrollElementRef, setScrollElementRef] = useState();

  const me = useSelector((state) => {
    return state.me;
  });

  const clientConfig = useSelector(getClientConfig);

  // TODO: Cex, remove only test - Enable network monitor module
  clientConfig.NETWORK_MONITOR_MODULE_ENABLED =
    getTenantPreLoginConfig().company_name === 'Correos Express';

  const enabledTabs = Object.keys(clientConfig).filter((key) => clientConfig[key]);

  const dialogOptions = {
    user: {
      email: me?.username,
      id: me?.id,
      name: me?.name,
    },
  };

  useEffect(() => {
    initApp();
  }, [initApp]);

  useLayoutEffect(() => {
    setScrollElementRef(scrollElement);
  }, []);

  if (appLoading) {
    return <LoadingBig />;
  }

  const isTopBarElevated = getTenantPreLoginConfig().company_name === 'Ontime';

  return (
    <ErrorBoundary fallback={FallbackErrorComponent} showDialog dialogOptions={dialogOptions}>
      <FeatureFlagProvider>
        <TopBarMenuButtonStateProvider>
          <AppContainerDiv>
            <TopContainer elevated={isTopBarElevated}>
              <Topbar />
            </TopContainer>
            <ContentContainer ref={scrollElement}>
              <ScrollElementContext.Provider value={scrollElementRef}>
                {routes.map((route) => (
                  <React.Fragment key={route.path}>
                    {(enabledTabs.includes(route.requiredFlag) || !route.requiredFlag) && (
                      <Route
                        key={route.path}
                        path={route.path}
                        exact={route.exact}
                        component={route.component}
                      />
                    )}
                  </React.Fragment>
                ))}
              </ScrollElementContext.Provider>
            </ContentContainer>
            <Snackbar />
            <ErrorFeedback />
          </AppContainerDiv>
        </TopBarMenuButtonStateProvider>
      </FeatureFlagProvider>
    </ErrorBoundary>
  );
};

LoggedRoutes.propTypes = {
  initApp: PropTypes.func,
  appLoading: PropTypes.bool,
};

export default connect((state) => {
  return {
    appLoading: state.app.loading,
  };
}, actionCreators)(LoggedRoutes);
